import {
  BackgroundColor as HygraphBackgroundColor,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import {
  BackgroundColor,
  backgroundColorToEnumMap,
} from '@/enums/background-color';

export default function backgroundColorTransformer(
  props: HygraphMaybe<HygraphBackgroundColor> | undefined
): BackgroundColor | undefined {
  if (!props) return BackgroundColor.WHITE;

  return backgroundColorToEnumMap[props];
}
